export function handleResizeColumn(w: number, col: any) {
  col.width = w;
}
